import stylesHeader from "../header/Header.module.css";
import stylesProfiloUtente from "./ProfiloUtente.module.css"
import React, {useState} from "react";
import NavbarDropdown from "../navbarDropdown/NavbarDropdown";
import {useDispatch} from "react-redux";
import Spinner from "../spinner/Spinner";
import auth from "../../../src/utils/AthnAuth";

function ProfiloUtente(props) {

    let dropDownList = [{label: "LOGOUT", onClick: onClickLogout, href: "/logout"}]
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const dispatch = useDispatch()
    const [showSpinner, setShowSpinner] = useState(false)

    function onClickAccedi() {
        setShowSpinner(true)
        auth.login().then(r => {}).catch((error) => {
            console.log("Not signed in");
            console.error(`Errore: ${error}`);
        });
        setShowSpinner(false)
    }

    function onClickLogout() {
        setShowSpinner(true)
        let sessione = {tipoUtente: "03",loggedIn:false}
        sessionStorage.setItem("sessioneUtente",JSON.stringify(sessione))
        setShowSpinner(false)
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            {sessioneUtente && sessioneUtente.tipoUtente !== "03" ?
                <div id="profiloUtente" className={stylesHeader.stileProfilo} style={{maxWidth: "350px", marginLeft: "auto"}}>
                    <svg width={"60"} fill={"white"} viewBox="0 0 24 24" id="it-user"
                         xmlns="http://www.w3.org/2000/svg"
                         style={{border: "1px solid white", borderRadius: "100px", padding: "15px", alignSelf: "center"}}>
                        <path
                            d="M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"/>
                        <path fill="none" d="M0 0h24v24H0z"/>
                    </svg>
                    <div className={stylesProfiloUtente.styleNomeInfo}>
                        <p className={stylesProfiloUtente.noPaddingMargin}/>
                        <ul className={stylesProfiloUtente.noPaddingMargin}>
                            <li
                                className={[
                                    stylesProfiloUtente.styleProfiloLi,
                                    stylesProfiloUtente.liPagina,
                                    stylesProfiloUtente.noPaddingMargin
                                ].join(' ')}
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style={{
                                    background: "transparent",
                                    display: (sessioneUtente.tipoUtente === "02" || sessioneUtente.tipoUtente === "04") ? "flex" : "",
                                    alignItems: (sessioneUtente.tipoUtente === "02" || sessioneUtente.tipoUtente === "04") ? "center" : ""
                                }}
                            >
                                <div className={"row"}>
                                    <div className={"col-12"}>
                                        <div className={stylesProfiloUtente.informazioni}>
                                            <div className={"row"}>
                                            <span style={{fontSize: "16px", lineHeight: "24px", fontWeight: "bold"}}>
                                                {sessioneUtente && sessioneUtente.nome && sessioneUtente.cognome ?
                                                    sessioneUtente.nome + " " +sessioneUtente.cognome : ""}
                                            </span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" className="icon-sm icon-white">
                                                    <title>Arrow Down</title>
                                                    <g>
                                                        <path
                                                            d="M9.2,12h5.6a1,1,0,0,1,.7,1.7L12,17.3,8.5,13.7A1,1,0,0,1,9.2,12Z"/>
                                                    </g>
                                                    <g>
                                                        <rect width="24" height="24" fill="none"/>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className={"row"}>
                                                <span style={{fontSize: "14px", fontWeight: "normal"}}>
                                                    {sessioneUtente.tipoUtente === "01" ? sessioneUtente.ruolo : ""}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <NavbarDropdown dropDownList={dropDownList}/>
                        </ul>
                    </div>
                </div> :
                <div className={"row"} style={{alignItems: "center", justifyContent: "center"}}>

                    <button type="button" className={"col-2 offset-7"} onClick={onClickAccedi}
                            aria-label={"Accedi"}
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                font: "inherit",
                                color: "inherit",
                                textAlign: "inherit",
                                cursor: "pointer"
                            }}>
                        <svg width={"60"} fill={"white"} viewBox="0 0 24 24" id="it-user"
                             xmlns="http://www.w3.org/2000/svg"
                             style={{border: "1px solid white", borderRadius: "100px", padding: "15px"}}>
                            <path
                                d="M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>
                    </button>
                    <button type="button" className={"col-3"} onClick={onClickAccedi}
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                font: "inherit",
                                color: "inherit",
                                textAlign: "inherit",
                                cursor: "pointer"
                            }}>
                        <span style={{
                            color: "white",
                            fontSize: "16px",
                            textDecoration: "underline",
                            fontWeight: "bold"
                        }}>Accedi</span>
                    </button>
                </div>
            }</div>
    )


}

export default ProfiloUtente
